import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { fadeAnimations } from '../../animations/fading.animation';

@Component({
  selector: 'atram-modal',
  templateUrl: './atram-modal.component.html',
  styleUrls: ['./atram-modal.component.less'],
  animations: [fadeAnimations.default, fadeAnimations.down]
})
export class AtramModalComponent implements OnInit {

  @Input() size: string = 'sm';
  @Input() status: string= '';
  @Input() headerText: string= '';
  @Input() bodyText: string= '';
  @Input() hasInputText: boolean = false;
  @Input() inputTextLabel: string = '';
  @Input() inputTextPlaceholder: string = '';
  @Input() isInputTextRequired: boolean = false;
  @Input() isInputTextError: boolean = false;
  @Input() okButtonText: string = 'OK';
  @Input() cancelButtonText: string = 'Cancel';
  @Input() showCancelButton: boolean = true;
  @Input() showCloseButton: boolean = true;
  @Input() showButtonsInline: boolean = false;
  @Input() spSiteFolterPath: string = '';

  public inputText: FormControl = new FormControl('', [Validators.required]);
  public confirmationSubject: Subject<any>;
  public activeModal: boolean = false;

  constructor() {
    this.confirmationSubject = new Subject<any>();
  }

  ngOnInit() {
  }

  public show(): void {
    this.activeModal = true;
  }

  public hide(): void {
    this.size = 'sm';
    this.hasInputText = false;
    this.inputTextLabel = '';
    this.inputTextPlaceholder = '';
    this.isInputTextRequired = false;
    this.isInputTextError = false;

    this.inputText.setValue('');
    this.activeModal = false;
  }

  public onClickOk(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.hasInputText) {
      if (this.isInputTextRequired && !this.inputText.valid) {
        this.isInputTextError = true;
        return;
      }

      this.confirmationSubject.next({
        subject: true,
        inputTextValue: this.inputText.value
      });
    } else {
      this.confirmationSubject.next(true);
    }
    this.confirmationSubject = new Subject<any>();
  }

  public onClickCancel(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.confirmationSubject.next(false);
    this.confirmationSubject = new Subject<any>();
  }
}
